import React, { useState } from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const OtherMainteneance = () => {
  const [isReceiptOpen, setIsReceiptOpen] = useState(false);
  const handleReceiptClick = (row, receiptIndex) => {
    console.log("Clicked receipt", receiptIndex, "for row:", row);
    setIsReceiptOpen(true);
  };
  const columns = [
    {
      key: "receiptId",
      label: "Receipt id/Time",
      render: (row) => (
        <div>
          <div>{row.receiptId}</div>
          <div style={{ color: "#f97316", fontSize: "12px" }}>{row.time}</div>
        </div>
      ),
    },
    {
      key: "mealSchedule",
      label: "Meal schedule",
      render: (row) => (
        <div>
          <div>{row.mealDay}</div>
          <div style={{ color: "#22c55e", fontSize: "12px" }}>
            {row.mealItems}
          </div>
        </div>
      ),
    },
    {
      key: "orderDetails",
      label: "Order details",
      render: (row) => (
        <div>
          {row.order.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </div>
      ),
    },
    {
      key: "amount",
      label: "Amount (INR)",
      render: (row) => (
        <div>
          {row.amounts.map((amt, i) => (
            <div key={i}>₹ {amt}</div>
          ))}
          <div style={{ marginTop: "4px", fontWeight: "500" }}>
            Total: <span style={{ color: "#5D87FF" }}>₹ {row.total}</span>
          </div>
        </div>
      ),
    },
    {
      key: "paid",
      label: "Paid amount (INR)",
      render: (row) => (
        <div>
          <div>₹ {row.paidAmount}</div>
          <div style={{ fontSize: "12px", color: "#64748b" }}>
            {row.paymentMethod}
          </div>
        </div>
      ),
    },
    {
      key: "vendor",
      label: "Vendor details",
      render: (row) => (
        <div>
          <div>{row.vendor}</div>
          <div style={{ fontSize: "12px", color: "#64748b" }}>
            Ph: {row.vendorPhone}
          </div>
        </div>
      ),
    },
    {
      key: "confirmedBy",
      label: "Confirmed by",
      render: (row) => <div>{row.confirmedBy}</div>,
    },
    {
      key: "receipts",
      label: "Receipts",
      render: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {row.receipts.map((receipt, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
              }}
            >
              <span
                onClick={() => handleReceiptClick(row, index)}
                style={{
                  color: "#5D87FF",
                  cursor: "pointer",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                Receipt
                <BsBoxArrowRight />
              </span>
              {receipt.status && (
                <span
                  style={{
                    fontSize: "12px",
                    padding: "2px 8px",
                    backgroundColor:
                      receipt.status === "All paid" ? "#4CAF50" : "#F29339",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  {receipt.status}
                </span>
              )}
            </div>
          ))}
        </div>
      ),
    },
  ];

  const historyData = [
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      mealDay: "Thursday",
      mealItems: "Alu dal, sabji, vat",
      order: ["Aloo (10 kg)", "Sabji (10 kg)"],
      amounts: [18000, 18000],
      total: 36000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      vendor: "Mahi Enterprise",
      vendorPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "Pay due" }],
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      mealDay: "Wednesday",
      mealItems: "Alu dal, sabji, vat",
      order: ["Aloo (10 kg)", "Aloo (10 kg)"],
      amounts: [18000, 18000],
      total: 36000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      vendor: "Mahi Enterprise",
      vendorPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "All paid" }],
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      mealDay: "Tuesday",
      mealItems: "Alu dal, sabji, vat",
      order: ["Aloo (10 kg)", "Aloo (10 kg)"],
      amounts: [18000, 18000],
      total: 36000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      vendor: "Mahi Enterprise",
      vendorPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "Pay due" }],
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      mealDay: "Monday",
      mealItems: "Alu dal, sabji, vat",
      order: ["Aloo (10 kg)", "Aloo (10 kg)"],
      amounts: [18000, 18000],
      total: 36000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      vendor: "Mahi Enterprise",
      vendorPhone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      receipts: [{ status: "Pay due" }, { status: "Pay due" }],
    },
  ];
  const _this = { columns, historyData, isReceiptOpen, setIsReceiptOpen };
  return <Body {..._this} />;
};

export default OtherMainteneance;
